import TaskStatusLabel from "@/components/TaskStatusLabel";
import { useEffect, useMemo, useState } from "react";
import { TaskStatus as TaskStatusType } from "@/consts/Task";
import { TaskStatusMap } from "@/types/project";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { Info } from "lucide-react";

type Props = {
  taskStatusMap: TaskStatusMap;
  isParticipating: boolean;
};

export default function TaskStatus({ taskStatusMap, isParticipating }: Props) {
  const [totalTasksCount, setTotalTasksCount] = useState(0);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  useEffect(() => {
    let total = 0;
    let completed = 0;

    for (const [status, count] of Object.entries(taskStatusMap)) {
      total += count;
      if (
        status === TaskStatusType.CLOSED ||
        status === TaskStatusType.CANCELED
      ) {
        completed += count;
      }
    }

    setTotalTasksCount(total);
    setCompletedTaskCount(completed);
  }, [taskStatusMap]);

  return (
    <div className="flex gap-1 items-center">
      <p className="text-sm text-gray-A font-semibold opacity-60">
        {completedTaskCount}/{totalTasksCount}
      </p>
      {isParticipating ? (
        <HoverCard openDelay={300} closeDelay={100}>
          <HoverCardTrigger>
            <Info className="text-gray-C size-[18px] cursor-pointer" />
          </HoverCardTrigger>
          <HoverCardContent className="w-[120px] p-3 flex flex-col gap-2">
            {Object.entries(taskStatusMap).map(([status, count]) => (
              <div key={status} className="flex items-center justify-between">
                <TaskStatusLabel status={status as TaskStatusType} />
                <span className="text-xs text-gray-A font-semibold">
                  {count}개
                </span>
              </div>
            ))}
          </HoverCardContent>
        </HoverCard>
      ) : (
        <Info className="text-gray-C size-[18px]" />
      )}
    </div>
  );
}
